import script from "./JaStreamGroupName.vue?vue&type=script&setup=true&lang=js"
export * from "./JaStreamGroupName.vue?vue&type=script&setup=true&lang=js"

import "./JaStreamGroupName.vue?vue&type=style&index=0&id=6f73c1c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f73c1c4"]])

export default __exports__